module.exports = __webpack_public_path__ + "img/yhj.f3710259.png";